import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import 'vuetify/dist/vuetify.min.css'
import fr from 'vuetify/es5/locale/fr'

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { fr },
        current: 'fr',
    },
    theme: {
        dark: false,
        themes: {
            light: { primary: '#3F51B5', secondary: '#607D8B', accent: '#FF4081', success: '#4CAF50', warning: '#FB8C00', error: '#FF5252', info: '#2196F3' },
            dark: { primary: '#7986CB', secondary: '#90A4AE', accent: '#FF80AB', success: '#66BB6A', warning: '#FFA726', error: '#FF5252', info: '#42A5F5' },
        },
    },
});
